import styled from "styled-components";

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  img {
    max-width: 340px;
    width: 100%;
  }

  p {
    color: #1a3458;
  }
`;
